import fetch from '../../auth/FetchInterceptor';

export const getInvoices = function (
  perPage,
  page,
  startDate,
  endDate,
  statusId
) {
  let params = `?per_page=${perPage}&page=${page}`;

  if (startDate) {
    params += `&from=${startDate}`;
  }

  if (endDate) {
    params += `&to=${endDate}`;
  }

  if (statusId) {
    params += `&status_id=${statusId}`;
  }

  return fetch({
    url: `/invoices${params}`,
    method: 'get',
  });
};

export const getInvoice = (id) => {
  return fetch({
    url: `/invoices/${id}`,
    method: 'GET',
  });
};

export const createInvoice = (data) => {
  return fetch({
    url: `/invoices`,
    method: 'POST',
    data,
  });
};

export const updateInvoice = (id, data) => {
  return fetch({
    url: `/invoices/${id}`,
    method: 'PUT',
    data,
  });
};

export const deleteInvoice = (id) => {
  return fetch({
    url: `/invoices/${id}`,
    method: 'DELETE',
  });
};

export const getInvoiceStatuses = () => {
  return fetch({
    url: `/invoices/statuses`,
    method: 'GET',
  });
};

export const printInvoice = async (id) => {
  const res = await fetch({
    url: `/invoices/${id}/pdf`,
    method: 'GET',
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf',
    },
  });
  const url = URL.createObjectURL(res);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Invoice-${id}.pdf`;
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 100);
};

export const getHtmlInvoice = async (id) => {
  return fetch({
    url: `/invoices/template/2/invoice/${id}`,
    method: 'GET',
  });
};

export const getInvoiceByAccessCode = (id, accessCode) => {
  return fetch({
    url: `/i/${id}/${accessCode}`,
    method: 'GET',
    headers: {
      'public-request': 'true',
    },
  });
};

export const getInvoiceCheckout = (id, accessCode) => {
  return fetch({
    url: `/i/${id}/${accessCode}/checkout`,
    method: 'POST',
    headers: {
      'public-request': 'true',
    },
  });
};

export const postApproveInvoice = (id, accessCode, signatureBlob) => {
  const formData = new FormData();
  formData.append('signature', signatureBlob);

  return fetch({
    url: `/i/${id}/${accessCode}/approve`,
    method: 'POST',
    data: formData,
    headers: {
      'public-request': 'true',
    },
  });
};

/**
 * Sends an invoice using a text message.
 *
 * @param {number} accountInvoiceId - is the account invoice's id. Please note that is not the same as the id property.
 * @param {string} to - is the destination number
 * @returns the response from the server.
 */
export const postInvoiceToText = (accountInvoiceId, to) => {
  const formData = new FormData();
  formData.append('to', to);

  return fetch({
    url: `/invoices/${accountInvoiceId}/text`,
    method: 'POST',
    data: formData,
  });
};

/**
 * Sends an invoice using an email.
 *
 * @param {number} accountInvoiceId - is the account invoice's id. Please note that is not the same as the id property.
 * @param {string} to - is the destination email
 * @returns the response from the server.
 */
export const postInvoiceToEmail = (accountInvoiceId, to) => {
  const formData = new FormData();
  formData.append('to', to);

  return fetch({
    url: `/invoices/${accountInvoiceId}/email`,
    method: 'POST',
    data: formData,
  });
};
